import React, { Component } from "react";
import "./connect.css";

export default class Connect extends Component {
  render() {
    return (
      <div className="col-12 row justify-content-center ml-0 mr-0 pl-0 pr-0">
        <div className="col-lg-3 col-xs-12 socialbox text-center shadow-lg pt-5 mb-4 mr-3 ml-3">
          <h1 className="textpink textspaced">GitHub</h1>
          <a
            href="https://github.com/Thakur-Sahab-4-5-2000"
            target="_blank"
            rel="noreferrer"
            className="socialicon-large"
          >
            <span className="icon-github"></span>
          </a>
          <hr className="navbreak" />
          <p className="text-white raleway pt-4">
            Check out the source code for some cool projects, including this
            portfolio!
          </p>
        </div>

        <div className="col-lg-3 col-xs-12 socialbox text-center shadow-lg pt-5 mb-4 mr-3 ml-3">
          <h1 className="textpink textspaced">Instagram</h1>
          <a
            href="https://www.instagram.com/____thakursaab_____/"
            target="_blank"
            rel="noreferrer"
            className="socialicon-large"
          >
            <span className="icon-instagram socialicon-large"></span>
          </a>
          <hr className="navbreak" />
          <p className="text-white raleway pt-4">
            Interested in checking my posts? <br /> 
            Check out my instagram profile.
            I hope you like my posts.
          </p>
        </div>

        <div className="col-lg-3 col-xs-12 socialbox text-center shadow-lg pt-5 mb-4 mr-3 ml-3">
          <h1 className="textpink textspaced">Facebook</h1>
          <a
            href="https://www.facebook.com/Huntershikaaribro/"
            target="_blank"
            rel="noreferrer"
            className="socialicon-large"
          >
            <span className="icon-facebook-square"></span>
          </a>
          <hr className="navbreak" />
          <p className="text-white raleway pt-4">
          Interested in checking my posts? <br /> 
            Check out my facebook profile.
            I hope you like my posts.
          </p>
        </div>
      </div>
    );
  }
}
